import { styled } from "styled-components";

export const Layout = styled.main`
    min-height: 100vh;
    background-color: var(--background-color, ${props => props.theme.grey4});
`